import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import EuReadinessMedtech from "@/pages/EuReadinessMedtech";

export const Route = createFileRoute("/en/eu-readiness-medtech")({
  head: () => buildRouteHead("/en/eu-readiness-medtech"),
  component: EuReadinessMedtech,
});

